import React from 'react'
import 'react-dates/lib/css/_datepicker.css'
import styled from 'styled-components'
import colors from 'constants/colors'
import {
  DateRangePicker,
  DateRangePickerShape,
  SingleDatePicker,
  SingleDatePickerShape,
} from 'react-dates'

const styles = `
  .DateRangePicker_picker {
    border-radius: 14px;
  }
  .DayPicker {
    box-shadow: 0 0 0 1px rgba(0,0,0,0.0), 0 4px 24px 2px rgba(0,0,0,0.1);
    border-radius: 14px;
  }
  .CalendarDay__selected_span {
    background: ${colors.primary};
    color: white;
    border-color: ${colors.primaryLight};
  }

  .CalendarDay__selected {
    background: ${colors.primaryDark};
    color: white;
    border-color: ${colors.primary};
  }

  .CalendarDay__selected:hover {
    background: ${colors.primaryLight};
    color: white;
    border-color: ${colors.primary};
  }

  .CalendarDay__selected_span:hover,
  .CalendarDay__hovered_span {
    background: ${colors.primaryLight};
    color: white;
    border-color: ${colors.primary};
  }

  .DateInput_input.DateInput_input__focused {
    border-bottom: 0;
    background-color: #fff;
    border-color: #80bdff;
    outline: 0;
    box-shadow: 0 0 0 0.2rem rgba(0,123,255,.25) inset;
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
    ::placeholder {
      color: ${colors.inputFocusedPlaceholder};
      opacity: 1;
    }
    
    :-ms-input-placeholder {
      color: ${colors.inputFocusedPlaceholder};
    }
    
    ::-ms-input-placeholder {
      color: ${colors.inputFocusedPlaceholder};
    }
  }

  .DateInput, .DateInput_input {
    background-color: transparent;
    font-family: Poppins;
    font-weight: 500;
    font-size: 16px;
    text-align: center;
    border-bottom: 0;
  }

  .DateInput_input {
    padding-top: 8px;
    padding-bottom: 6px;
  }

  .DateRangePickerInput,
  .SingleDatePickerInput {
    padding-right: 0;
    border-radius: 7px;
    border: 0;
    background-color: ${colors.inputGrey};
    height: calc(1.5em + .75rem + 2px);
  }

  .DateRangePickerInput_calendarIcon,
  .SingleDatePickerInput_calendarIcon {
    padding: 5px 0 5px 12px;
  }

  .DateRangePickerInput_calendarIcon:focus,
  .DateRangePickerInput_calendarIcon:hover,
  .SingleDatePickerInput_calendarIcon:focus,
  .SingleDatePickerInput_calendarIcon:hover {
    border: none;
    outline: none;
  }

  .DateRangePickerInput_clearDates_default:focus,
  .DateRangePickerInput_clearDates_default:hover,
  .SingleDatePickerInput_clearDate:focus,
  .SingleDatePickerInput_clearDate:hover {
    background: none;
  }

  .DateRangePickerInput_clearDates {
    float: right;
    overflow: visible;
    cursor: pointer;
    padding: 10px;
    display: inline-block;
    margin: 0 10px 0 5px;
    position: inherit;
    right: inherit;
    top: inherit;
    transform: translateY(-13%);
  }

  .SingleDatePickerInput_clearDate {
    float: right;
    overflow: visible;
    cursor: pointer;
    padding: 10px 10px 10px 0;
    display: inline-block;
    margin: 0 10px 0 5px;
    position: inherit;
    right: inherit;
    top: inherit;
    transform: translateY(-13%);
  }

  .DateRangePickerInput_clearDates__hide {
    display: none;
  }

  .DateRangePickerInput_arrow {
    margin-top: 0;
    margin-right: 3px;
  }

  .DateRangePickerInput_arrow_svg {
    height: 18px;
    width: 18px;
  }

  &.hideInputs {
    .DateInput {
      display: none;
    }

    .DateRangePickerInput_arrow {
      display: none;
    }

    .DateRangePicker {
      position: inherit;
    }
  }
`

export const StyledDateRangePicker = styled((props: DateRangePickerShape & { className?: string }) => {
  const { className, ...rest } = props
  return (
    <span className={className}>
      <DateRangePicker {...rest} />
    </span>
  )
})`${styles}`

export const StyledSingleDatePicker = styled((props: SingleDatePickerShape & { className?: string }) => {
  const { className, ...rest } = props
  return (
    <span className={className}>
      <SingleDatePicker {...rest} />
    </span>
  )
})`${styles}`
